/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import React from 'react';
import './Toggle.scss';

export default class Toggle extends React.Component {
  constructor(props) {
    super(props);

    this.select = this.select.bind(this);
    this.checked = this.props.selected;
  }

  UNSAFE_componentWillUpdate(nextProps) {
    this.checked = nextProps.selected;
  }

  select(e) {
    this.checked = !this.checked;

    if (this.props.onChange) {
      this.props.onChange.call(e, this.props.accountId, this.checked);
    }
  }

  render() {
    return (
      <span
        className={`toggle-span ${this.checked ? 'checked' : ''}`}
        onClick={this.select}
        ref={this.props.accountId + '-' + this.props.index}></span>
    );
  }
}
